import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4efa56a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = { class: "p-d-flex p-flex-row" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "required" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "p-d-flex p-flex-row" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "p-d-flex p-flex-row" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_19 = { class: "container-select-input" }
const _hoisted_20 = { class: "p-input-icon-left" }
const _hoisted_21 = { class: "icon-container" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "filler"
}
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.t("onboarding.step-personal.first-name")), 1),
          _hoisted_5
        ]),
        _createElementVNode("input", {
          type: "text",
          value: _ctx.user.firstName,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeFirstName && _ctx.changeFirstName(...args))),
          required: ""
        }, null, 40, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.t("onboarding.step-personal.last-name")), 1),
          _hoisted_8
        ]),
        _createElementVNode("input", {
          type: "text",
          value: _ctx.user.lastName,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeLastName && _ctx.changeLastName(...args))),
          required: ""
        }, null, 40, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.t("onboarding.step-personal.email")), 1),
          _hoisted_12
        ]),
        _createElementVNode("input", {
          type: "text",
          value: _ctx.user.email,
          required: "",
          disabled: ""
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("onboarding.step-personal.phone")), 1),
        _createElementVNode("input", {
          type: "text",
          value: _ctx.user.phone,
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePhone && _ctx.changePhone(...args)))
        }, null, 40, _hoisted_15)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.t("onboarding.step-personal.country")), 1),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "overlaypanel-content",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteSelectionCountry()))
          }, [
            _createElementVNode("span", _hoisted_20, [
              _createVNode(_component_InputText, {
                class: "input-form-student",
                type: "text",
                autocomplete: "off",
                modelValue: _ctx.searchCountry,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchCountry) = $event)),
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchCountries()))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  class: "arrow",
                  src: require('@/assets/icons/caret_down.svg'),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSelectedItem(!_ctx.isItemSelected) ))
                }, null, 8, _hoisted_22)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["search-result-container", { 'disable-results': _ctx.isItemSelected }]),
            style: _normalizeStyle(_ctx.filteredCountry.length ? 'opacity: 1;' : 'opacity: 0;')
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountry, (country) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: country,
                  class: "search-result-container__item",
                  onClick: ($event: any) => (_ctx.selectItemCountry(country))
                }, _toDisplayString(country.country), 9, _hoisted_23))
              }), 128)),
              (_ctx.filteredCountry.length > 9)
                ? (_openBlock(), _createElementBlock("li", _hoisted_24))
                : _createCommentVNode("", true)
            ])
          ], 6)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("onboarding.step-personal.city")), 1),
        _createElementVNode("input", {
          type: "text",
          value: _ctx.user.cityV2,
          onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeCity && _ctx.changeCity(...args)))
        }, null, 40, _hoisted_26)
      ])
    ])
  ]))
}